<template>
    <div class="container" :style="{marginTop: '20px'}">
        <div class="box-title">
            <h4>
                <i class="fal fa-gifts"></i>
                ລາຍການທັງໝົດ
                <span class="countTotal">({{totalOrder}})</span>
            </h4>
        </div>

        <div class="box">
            <div class="columns">
                <div class="column is-4">
                    <div class="control">
                        <div class="filed">
                            <label class="label">ຄົ້ນຫາ</label>
                            <div class="control">
                                <input class="input" placeholder="ຄົ້ນຫາ ລະຫັດລາຍການ..." v-model="searchOrderId">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="control">
                        <label class="label">ເເຕ່ວັນທີ</label>
                        <vuejs-datepicker 
                            v-model="startDate" 
                            input-class="input"
                            format="d-M-yyyy"
                            name="valid_date"
                            v-validate="'required'"
                        >
                        </vuejs-datepicker>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="control">
                        <label class="label">ຫາວັນທີ</label>
                        <vuejs-datepicker 
                            v-model="endDate" 
                            input-class="input"
                            format="d-M-yyyy"
                            name="valid_date"
                            v-validate="'required'"
                        >
                        </vuejs-datepicker>
                    </div>
                </div>
            </div>
        </div>

        <div class="center">
            <vs-table>
                <template #thead>
                    <vs-tr>
                        <vs-th>ລຳດັບ</vs-th>
                        <vs-th>ລະຫັດ ລາຍການ</vs-th>
                        <vs-th>ປະເພດພາຫະນະ</vs-th>
                        <vs-th>ຊື່ລູກຄ້າ</vs-th>
                        <vs-th>ປະເພດພັດສະດຸ</vs-th>
                        <vs-th>ຈຳນວນ</vs-th>
                        <vs-th>ນ້ຳໜັກ</vs-th>
                        <vs-th>ວັນທີ່ສ້າງລາຍການ</vs-th>
                        <vs-th>ເວລານັດຮັບເຄື່ອງ</vs-th>
                        <vs-th>ຜູ້ປະຕິເສດ</vs-th>
                        <vs-th>ສະຖານະ</vs-th>
                        <vs-th></vs-th>
                    </vs-tr>
                </template>
                <template #tbody>
                    <vs-tr
                        :key="index" v-for="(orderReject, index) in FilterOrderRequestReject"
                    >
                        <vs-td>{{ index + 1 }}</vs-td>
                        <vs-td :style="{width: '15%', color: 'crimson'}">
                            ( {{orderReject.order_id}} )
                        </vs-td>
                        <vs-td>
                            <span v-if="orderReject.vehicle_type == 'motorcycle'">ລົດຈັກ</span>
                            <span v-if="orderReject.vehicle_type == 'car'">ລົດໃຫຍ່</span>
                        </vs-td>
                        <vs-td>{{orderReject.customer_name}}</vs-td>
                        <vs-td>{{orderReject.categ_name}}</vs-td>
                        <vs-td>{{orderReject.amount}}</vs-td>
                        <vs-td>{{orderReject.weight}} kg</vs-td>
                        <vs-td>{{FormatDate(orderReject.created_at)}}</vs-td>
                        <vs-td>
                            {{FormatDateSchedule(orderReject.schedule)}}
                            <span>
                                - {{orderReject.schedule_time !== null ? orderReject.schedule_time : '..............'}}
                            </span>
                        </vs-td>
                        <vs-td>
                            <span :style="{color: '#195BFF'}">
                                ( {{orderReject.rider_name !== null ? orderReject.rider_name : '.................'}} )
                            </span>
                        </vs-td>
                        <vs-td>
                            <span v-if="orderReject.status == 'reject'" :style="{color: 'crimson', textDecoration: 'underline'}">
                                ປະຕິເສດເເລ້ວ
                            </span>
                        </vs-td>
                        <vs-td style="text-align: right; width: 100px">
                            <div class="group-icon">
                                <vs-button circle icon flat @click="OpenModal_ReasonCancelOrderRequest(orderReject.id)">
                                    <i class="fal fa-eye"></i>
                                </vs-button>
                                <vs-button circle icon flat @click="OpenModal_RejectOrderRequest(orderReject.id)">
                                    <i class="fal fa-folder-open"></i>
                                </vs-button>
                            </div>
                        </vs-td>  
                    </vs-tr>
                </template>
                <template #footer>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset" @paginate="FetchRejectOrderRequest()"></pagination>
                    <Loading v-if="isLoading"/>
                </template>
            </vs-table>
        </div>

        <ModalDelete>
            <template v-slot="{ close }">
                <UnRejectOrderRequest @close="close" :orderRequestId="orderRequestId" @success="FetchOrderRequests()"/>
            </template>
        </ModalDelete>

        <ModalPreviewFile>
            <template v-slot="{ close }">
                <ViewReasonCancelOrderRequest @close="close" :OrderRequest="filterOrderRequest" @success="FetchOrderRequests()"/>
            </template>
        </ModalPreviewFile>

    </div>
</template>

<script>
import mixinsRejectOrderRequests from '@coms/../../src/Mixins/Order-Requests/RejectOrder';
import Loading from '../Loading';
import UnRejectOrderRequest from './Dialog/UnReject';
import ViewReasonCancelOrderRequest from './Dialog/View-Reason';
import moment from 'moment';
import vuejsDatepicker from 'vuejs-datepicker';
import pagination from '../../Plugins/Paginations/Pagination';


export default {
    components:{
        Loading,
        UnRejectOrderRequest,
        ViewReasonCancelOrderRequest,
        vuejsDatepicker,
        pagination
    },
    methods:{
        FormatDate(value){
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY - HH:mm:ss')
            }
        },
        FormatDateSchedule(date){
            if (date) {
                return moment(String(date)).format('DD/MM/YYYY')
            }
        },
        FormatStartDateAndEndDate(date){
            if (date) {
                return moment(String(date)).format('YYYY-MM-DD')
            }
        }
    },
    mixins:[mixinsRejectOrderRequests],

    created(){
        this.FetchRejectOrderRequest();
    }
}
</script>

<style>

</style>